import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiAutocomplete: {
  defaultProps?: ComponentsProps['MuiAutocomplete'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiAutocomplete'];
  variants?: ComponentsVariants['MuiAutocomplete'];
} = {
  defaultProps: {
    noOptionsText: 'Sin opciones',
    loadingText: 'Cargando ...',
  },
};

export default muiAutocomplete;
